import { http } from './shared';

export const CalendarService = {
  get: (params) => http.get('/calendar_sync', params),
  add: (params) => http.post(`/calendar_sync`, params),
  remove: (params) => http.delete(`/calendar_sync`, params),
};
